import React, { useState, useEffect } from "react";
import * as FileSaver from "file-saver";
import SearchHeader from "../Reuseablecomponent/SearchHeader";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import FormikControl from "../formikcontrols";
import { Modal, Button } from "react-bootstrap";
import "./createCV.scss";
import {
  frameworkOptionsUtility,
  resourcesListCount,
  resourcesNameList,
} from "../../customHooks";
import { ideOptionsUtility } from "../../customHooks";
import { languageOptionsUtility } from "../../customHooks";
import { versionControlOptionsUtility } from "../../customHooks";
import { googleComponentOptionsUtility } from "../../customHooks";
import { operatingSystemOptionsUtility } from "../../customHooks";
import { webServicesOptionsUtility } from "../../customHooks";
import { toolsOptionsUtility } from "../../customHooks";
import { otherSkillsOptionsUtility } from "../../customHooks";
import { privateRequest } from "../../api/apiConfig/privateRequest";
import { useParams } from "react-router-dom";

const CreateCV = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [exOptions, setExOptions] = useState([]);
  const [frameworkOptions, setFrameworkOptions] = useState([]);
  const [ideOptions, setIdeOptions] = useState([]);
  const [languageOptions, setLangaugeOptions] = useState([]);
  const [versionControlOptions, setVersionControlOptions] = useState([]);
  const [googleComponentsOptions, setGoogleComponentsOptions] = useState([]);
  const [operatingSystemOptions, setOperatingSystemOptions] = useState([]);
  const [webServicesOptions, setWebServicesOptions] = useState([]);
  const [toolsOptions, setToolsOptions] = useState([]);
  const [otherSkillsOptions, setOtherSkillsOptions] = useState([]);
  const [resourcesName, setResourcesName] = useState([]);

  // const openModal = (e,value) => {
  //   setIsOpen(true)
  //   setData(value)
  // }
  // const closeModal = () => {
  // setIsOpen(false)
  //}

  const getLanguageOptions = async () => {
    const options = await languageOptionsUtility("name", "id");
    setLangaugeOptions(options);
  };

  const getFrameworkOptions = async () => {
    const options = await frameworkOptionsUtility("name", "id");
    setFrameworkOptions(options);
  };

  const getIdeOptions = async () => {
    const options = await ideOptionsUtility("name", "id");
    setIdeOptions(options);
  };

  const getVersionControlOptions = async () => {
    const options = await versionControlOptionsUtility("name", "id");
    setVersionControlOptions(options);
  };

  const getGoogleComponentsOptions = async () => {
    const options = await googleComponentOptionsUtility("name", "id");
    setGoogleComponentsOptions(options);
  };

  const getOperatingSystemOptions = async () => {
    const options = await operatingSystemOptionsUtility("name", "id");
    setOperatingSystemOptions(options);
  };

  const getWebServicesOptions = async () => {
    const options = await webServicesOptionsUtility("name", "id");
    setWebServicesOptions(options);
  };
  const getToolsOptions = async () => {
    const options = await toolsOptionsUtility("name", "id");
    setToolsOptions(options);
  };

  const getOtherSkillsOptions = async () => {
    const options = await otherSkillsOptionsUtility("name", "id");
    setOtherSkillsOptions(options);
  };

  const getResourcesName = async () => {
    const options = await resourcesNameList();
    setResourcesName(options);
  };

  const getToken = () => {
    if (localStorage.getItem("authUser") !== null) {
      const user = JSON.parse(localStorage.getItem("authUser"));
      return user.data.token;
    }
  };

  const handleSubmit = async (values) => {
    const config = {
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${getToken()}`,
        Accept: "application/pdf",
      },
    };
    privateRequest
      .post("cv", values, config)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", "resume.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => console.log(error.response));
  };

  const handleView = async (values) => {
    const config = {
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${getToken()}`,
        Accept: "application/pdf",
      },
    };
    privateRequest
      .post("cv", values, config)
      .then((response) => {
        var file = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      })
      .catch((error) => console.log(error.response));
  };

  const initialValues = {
    codeLanguageId: [],
    ideId: [],
    frameworkId: [],
    versionControlSystemId: [],
    externalComponentId: [],
    operatingSystemId: [],
    webServiceId: [],
    toolId: [],
    otherSkillId: [],
    userId: "",
  };

  const validationSchema = Yup.object().shape({
    codeLanguageId: Yup.array()
      .min(1, "Technology name is required")
      .required("Technology is required"),
    ideId: Yup.array()
      .min(1, "IDE name is required")
      .required("IDE is required"),
    frameworkId: Yup.array()
      .min(1, "Framework name is required")
      .required("Framework is required"),
    versionControlSystemId: Yup.array()
      .min(1, "Version control name is required")
      .required("Version control name is required"),
    externalComponentId: Yup.array()
      .min(1, "External Component name is required")
      .required("External component name required"),
    operatingSystemId: Yup.array()
      .min(1, "Operating system name is required")
      .required("Operating system required"),
    webServiceId: Yup.array()
      .min(1, "Web services name is required")
      .required("Web services name required"),
    toolId: Yup.array()
      .min(1, "Tools name is required")
      .required("Tools required"),
    otherSkillId: Yup.array()
      .min(1, "Other skills name is required")
      .required("Other skills required"),
    userId: Yup.array()
      .min(1, "User name is required")
      .required("User name required"),
  });

  useEffect(() => {
    getFrameworkOptions();
    getIdeOptions();
    getLanguageOptions();
    getVersionControlOptions();
    getGoogleComponentsOptions();
    getOperatingSystemOptions();
    getWebServicesOptions();
    getToolsOptions();
    getOtherSkillsOptions();
    getResourcesName();
  }, []);

  return (
    <div className="create-content-form">
      <SearchHeader title="Create CV" />
      <div className="create">
        <div className="create-content">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => {
              return (
                <Form className="create__sec--body-form">
                  <FormikControl
                    control="select"
                    label="Resources Name"
                    required={true}
                    form={formik}
                    options={resourcesName}
                    name="userId"
                  />

                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="Technology"
                    form={formik}
                    required={true}
                    options={languageOptions}
                    name="codeLanguageId"
                  />

                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="IDE (Software)"
                    form={formik}
                    required={true}
                    options={ideOptions}
                    name="ideId"
                  />
                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="Framework"
                    form={formik}
                    required={true}
                    options={frameworkOptions}
                    name="frameworkId"
                  />
                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="Version Control System"
                    form={formik}
                    required={true}
                    options={versionControlOptions}
                    name="versionControlSystemId"
                  />
                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="External Components"
                    form={formik}
                    required={true}
                    options={googleComponentsOptions}
                    name="externalComponentId"
                  />
                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="Operating System"
                    form={formik}
                    required={true}
                    options={operatingSystemOptions}
                    name="operatingSystemId"
                  />
                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="Web Services"
                    form={formik}
                    required={true}
                    options={webServicesOptions}
                    name="webServiceId"
                  />
                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="Tools"
                    form={formik}
                    required={true}
                    options={toolsOptions}
                    name="toolId"
                  />
                  <FormikControl
                    isMulti={true}
                    control="select"
                    label="Other Skills"
                    form={formik}
                    required={true}
                    options={otherSkillsOptions}
                    name="otherSkillId"
                  />

                  <div className="create__sec--body-form-bottom">
                    <div className="first">
                      <button type="submit" className="create__sec--btn1">
                        <span>Download</span>
                        {/* <i class="fa-solid fa-circle-arrow-down"></i> */}
                      </button>
                    </div>

                    <div className="second">
                      <span
                        onClick={() => handleView(formik.values)}
                        className="create__sec--btn"
                      >
                        View
                      </span>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default CreateCV;
